import { useQuery } from "@tanstack/react-query";
import { getInboundDocumentJobsNeedingReview } from "#/api/inbound-document-jobs.api";
import { InboundDocumentJob } from "#/api/inbound-document-jobs.type";

const queryKey = ["inbound-document-jobs", "needs-review"] as const;

export function useInboundDocumentJobsNeedingReview(options?: {
  enabled?: boolean;
}) {
  const { enabled = true } = options ?? {};
  return useQuery<InboundDocumentJob[]>({
    queryKey,
    queryFn: getInboundDocumentJobsNeedingReview,
    staleTime: 30_000,
    enabled,
  });
}

export function inboundDocumentJobsNeedsReviewQueryKey() {
  return queryKey;
}

export default useInboundDocumentJobsNeedingReview;
